import axios from "axios";

// Same-origin API base — always talk to the host the user actually loaded.
// This prevents cross-origin failures when the user visits an alternate host
// (e.g. https://www.loftpress.shop) that the hardcoded REACT_APP_BACKEND_URL
// (https://loftpress.shop) would otherwise trigger. Falls back to the build-
// time env var during SSR / non-browser contexts.
const BROWSER_ORIGIN =
  typeof window !== "undefined" && window.location && window.location.origin
    ? window.location.origin
    : (process.env.REACT_APP_BACKEND_URL || "");

export const API_BASE = `${BROWSER_ORIGIN}/api`;

export const api = axios.create({
  baseURL: BROWSER_ORIGIN,
  withCredentials: true,
});

// Format FastAPI validation errors as strings
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
